import { GET_VALIDATE_VALUE } from '../actions/actionTypes';

const initialState = {
    validateValue: false
}

export const parecerComportamentalReducer = (state = initialState, action: any) => {
        if (action.type === GET_VALIDATE_VALUE) {
        return {
            ...state,
            validateValue: action.validateValue
        };
    } else {
        return state;
    }
}